import { useState, useCallback, useEffect } from "react"
import { faCopy, faCheck } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

interface CopyButtonProps {
  textToCopy: string
}

export const CopyButton: React.FC<CopyButtonProps> = ({ textToCopy }) => {
  const [isCopied, setIsCopied] = useState(false)

  useEffect(() => {
    if (isCopied) {
      setTimeout(() => {
        setIsCopied(false)
      }, 2000)
    }
  }, [isCopied])

  const handleCopy = useCallback(() => {
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        setIsCopied(true)
      })
      .catch(() => {
        // Handle error silently
      });
  }, [textToCopy]);

  return (
    <button
      style={{
        minWidth: 100,
        marginTop: 10,
        ...(isCopied ? { backgroundColor: '#10b981', color: 'white', border: 'none', borderRadius: 4 } : {}),
      }}
      onClick={handleCopy}
    >
      {isCopied ? (
        <FontAwesomeIcon icon={faCheck} />
      ) : (
        <FontAwesomeIcon icon={faCopy} />
      )}{' '}
      {isCopied ? 'Copied!' : 'Copy link'}
    </button>
  );
}